import 'slick-carousel';

export default {
  init() {
    // JavaScript to be fired on the home page
    $('.regular').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      fade: true,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./src/scripts/routes/home.js